import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function AttachmentIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.5 2c-3.04 0-5.5 2.46-5.5 5.5v9c0 2.21 1.79 4 4 4s4-1.79 4-4v-7c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v6.5c0 .28.22.5.5.5s.5-.22.5-.5V9.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v7c0 1.66-1.34 3-3 3s-3-1.34-3-3v-9c0-2.49 2.01-4.5 4.5-4.5s4.5 2.01 4.5 4.5v9.5c0 .28.22.5.5.5s.5-.22.5-.5V7.5c0-3.04-2.46-5.5-5.5-5.5z"
        fill={color}
      />
    </Svg>
  );
}

export default AttachmentIcon;
